import YearMonthDropDown from "src/components/YearMonthDropDown/YearMonthDropDown";
import { useStatData } from "src/context/StatContext";
import Stat_Dashboard_TopGraphs from "./Stat_Dashboard_TopGraphs";
import MyDivider from "src/components/layout/MyDivider";
import { TextField } from "@mui/material";
import { useState } from "react";

export default function Stat_Dashboard() {
  const {
    setSelectedMonth,
    setSelectedYear,
    comparingMonthsCount,
    setComparingMonthsCount,
    selectedYear,
    selectedMonth,
  } = useStatData();
  const [numberOfMonths, setNumberOfMonths] = useState(comparingMonthsCount);

  const handleMonthChange = (data) => {
    const { year, month } = data;
    setSelectedYear(year);
    setSelectedMonth(month);
  };

  return (
    <div>
      <div className="center" style={{ gap: 8 }}>
        <YearMonthDropDown
          onChange={handleMonthChange}
          defaultYear={selectedYear}
          defaultMonth={selectedMonth}
        />
        <TextField
          sx={{ width: "300px" }}
          label="Vertaa kuinka monen kuukauden keskiarvoon"
          variant="outlined"
          value={numberOfMonths}
          onChange={(e) => setNumberOfMonths(e.target.value)}
          onBlur={() => setComparingMonthsCount(numberOfMonths)}
        />
      </div>
      <MyDivider />
      <Stat_Dashboard_TopGraphs />
    </div>
  );
}
